/**************************************************
 * Nombre:       Formulario_Programa_Informacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useIngresarObjeto} from "../../../Modulo_formularios/Hooks/useIngresarObjeto";
import Formulario_Programa_Informacio_Informacion from "./Formulario_Programa_Informacio_Informacion";
import Tarjetas_Informacion from "../../Tarjeta/Tarjetas_Informacion";

const Formulario_Programa_Informacion = ({...props}) => {
    const {IngresarObjeto} = useIngresarObjeto({
        props: props,
        nombre: 'Agregar Item',
        dato: 'items',
        Tarjeta: Tarjetas_Informacion,
        Formulario: Formulario_Programa_Informacio_Informacion
    });

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Parrafo Informacion del programa'}
                                  dato={'informacion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <Typography>Items de información</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresarObjeto/>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_Informacion